import { render, staticRenderFns } from "./RentalListItem.vue?vue&type=template&id=b724c2a6"
import script from "./RentalListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./RentalListItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports